import * as CoreFns from '../utilities/CoreFns';
import SmartContractsPartClean from './SmartContractsPartClean';
import DropdownMenu from '../StockItems/DropdownMenu';
import DoGuide from './DoGuide';

function App(props) {

  var organicChanges = props.organicChanges;
  var currentList = props.currentList;
  var signKey = props.signKey;
  var userID = props.userID;
  var logInState = props.logInState;
  var sessionID = props.sessionID;
  var userNos = props.userNos;
  var addToExtraScreen = props.addToExtraScreen;
  var tempAddr = props.tempAddr;
  var setTempAddr = props.setTempAddr;
  var chains = props.chains;

  var currentBlockchain = CoreFns.getChainDAppIsOn(currentList);

  function clickBCCell(aCell){
    var changes = [{t:'w',w:['_g','curr', 'o'],n:aCell}];
    organicChanges(changes);      
  }

  var solOut = chains.map((aC, index)=>{return {n:aC.n1, i:aC.ci, img:aC.a}});
  var smartContractsPart;
  if (currentBlockchain){

    var chainId = +CoreFns.relevantChainId(currentList);
    var smartContracts = currentList.sc;

    function updateExistingSCWithNewChain(whichSc, n){
      var addSet = {};
      addSet[chainId] = n;
      var m = {t:-1, addSet};
      var relevantBit = ['sc', whichSc];
      var changes = [{t:'w',w:relevantBit,n:m}];
      organicChanges(changes);
    }

    function addNewSc(n){
        var uuid = CoreFns.uuidScoped(userNos, currentList, ['sc'], []);
        updateExistingSCWithNewChain(uuid, n);
    }

    function deleteSc(aScKey){
        var changes = [{t:'r',w:['sc'],i:aScKey}];
        organicChanges(changes);
    }

    smartContractsPart = <SmartContractsPartClean chains={chains} signKey={signKey} userID={userID} logInState={logInState} sessionID={sessionID} chainId={chainId} smartContracts={smartContracts} updateExistingSCWithNewChain={updateExistingSCWithNewChain} addNewSc={addNewSc} deleteSc={deleteSc} tempAddr={tempAddr} setTempAddr={setTempAddr} addToExtraScreen={addToExtraScreen} organicChanges={organicChanges}/>


  }


   return <div className='container' >
            <center>
              <br/><DoGuide addToExtraScreen={addToExtraScreen} set={{t:'tabContracts'}} /><br/>
              <DropdownMenu clickItemInSelect={clickBCCell} options={solOut} currentAnswer={currentBlockchain}/>
              <br/>
              {smartContractsPart}
          </center>
          </div>


}


export default App;
